// extracted by mini-css-extract-plugin
module.exports = {"page":"RegistrationPage_page__kZj2O page_page__31uF2"};